
import { AdminLayout } from "@/components/admin/AdminLayout";
import { Card } from "@/components/ui/card";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";

export const AdminDashboard = () => {
  const navigate = useNavigate();
  
  const { data: stats, isLoading } = useQuery({
    queryKey: ['admin-stats'],
    queryFn: async () => {
      const [
        mealsResult,
        chefsRoleResult,
        usersResult,
        transactionsResult
      ] = await Promise.all([
        supabase.from('meals').select('count').single(),
        supabase.from('user_roles').select('count').eq('role', 'cook').single(),
        supabase.from('profiles').select('count').single(),
        supabase.from('transactions')
          .select('*')
          .then(({ data }) => ({
            count: data?.length || 0,
            sum: data?.reduce((acc, curr) => acc + (Number(curr.amount) || 0), 0) || 0
          }))
      ]);

      return {
        totalMeals: mealsResult.data?.count || 0,
        totalChefs: chefsRoleResult.data?.count || 0,
        totalFoodies: usersResult.data?.count || 0, // All users are foodies
        totalTransactions: transactionsResult.count,
        totalVolume: transactionsResult.sum
      };
    }
  });

  const handleTransactionClick = () => {
    navigate('/admin/transactions');
  };

  return (
    <AdminLayout title="Dashboard">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Card className="p-4">
          <h3 className="text-sm font-medium text-muted-foreground">Total Meals</h3>
          <p className="text-2xl font-bold">{isLoading ? '...' : stats?.totalMeals}</p>
        </Card>
        
        <Card className="p-4">
          <h3 className="text-sm font-medium text-muted-foreground">Total Chefs</h3>
          <p className="text-2xl font-bold">{isLoading ? '...' : stats?.totalChefs}</p>
        </Card>
        
        <Card className="p-4">
          <h3 className="text-sm font-medium text-muted-foreground">Total Foodies</h3>
          <p className="text-2xl font-bold">{isLoading ? '...' : stats?.totalFoodies}</p>
        </Card>
        
        <Card 
          className="p-4 cursor-pointer hover:bg-accent transition-colors"
          onClick={handleTransactionClick}
        >
          <h3 className="text-sm font-medium text-muted-foreground">Total Transactions</h3>
          <p className="text-2xl font-bold">{isLoading ? '...' : stats?.totalTransactions}</p>
        </Card>
        
        <Card 
          className="p-4 cursor-pointer hover:bg-accent transition-colors"
          onClick={handleTransactionClick}
        >
          <h3 className="text-sm font-medium text-muted-foreground">Total Volume</h3>
          <p className="text-2xl font-bold">
            ${isLoading ? '...' : ((stats?.totalVolume as number) || 0).toFixed(2)}
          </p>
        </Card>
      </div>
    </AdminLayout>
  );
};
